<p-progressBar class="progress-bar {{progress < 100 ? 'not-done' : 'done'}} {{negative ? 'negative' : 'positive'}}"
    [value]="progress"></p-progressBar>